package fr.arcplex.sooner.webui

import fr.arcplex.network.model.Rail
import fr.arcplex.network.model.RailItem

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import fr.arcplex.sooner.ui.theme.TVTxt

@Composable
fun RailView(
    rail: Rail,
    modifier: Modifier = Modifier,
    centerContent: Boolean = false,
    itemMargin: Dp = 8.dp,
    onRailItemClicked: ((RailItem) -> Unit)? = null,
    isTV: Boolean = false
) {
    val rowPadding = if (isTV) {
        androidx.compose.foundation.layout.PaddingValues(horizontal = 24.dp, vertical = 4.dp)
    } else {
        androidx.compose.foundation.layout.PaddingValues(horizontal = 4.dp, vertical = 2.dp)
    }
    val verticalSpacing = if (isTV) 16.dp else 8.dp
    val listState = rememberLazyListState()

    // A refreshed rail (search results) must show its first item again.
    LaunchedEffect(rail.uid, rail.items.map { it.uid }) {
        listState.scrollToItem(0)
    }

    androidx.compose.foundation.layout.Column(
        horizontalAlignment = if (centerContent) Alignment.CenterHorizontally else Alignment.Start,
        modifier = modifier.fillMaxWidth().padding(vertical = verticalSpacing)
    ) {
        if (!rail.label.isNullOrEmpty()) {
            Text(
                rail.label.orEmpty(),
                color = TVTxt,
                fontSize = 12.sp,
                fontWeight = FontWeight.Medium,
                maxLines = 1,
                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 8.dp).padding(bottom = 4.dp)
            )
        }

        LazyRow(
            state = listState,
            contentPadding = rowPadding,
            horizontalArrangement = Arrangement.spacedBy(6.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            items(rail.items, key = { "${rail.uid}:${it.uid}" }) { item ->
                RailItemView(
                    modifier = Modifier,
                    isTV = isTV,
                    // Same gate as pre-migration: an item without an action URL is inert.
                    onItemClick = { if (item.action?.url != null) onRailItemClicked?.invoke(item) }
                ) { RailItemContent(item) }
            }
        }
    }
}
